export const HUMAN_RESOURCES_MODULE_NAME = "humanresources";
